// [DASHBOARD CARDS] Configuration des cartes du dashboard - Système AI Credits
// [RÔLE] Retourne les données formatées pour l'affichage des KPIs
// [CLIENT] famla-app = AI Credits UNIQUEMENT
// [BACKOFFICE] famla-backoffice = Tokens + AI Credits

/**
 * Génère les données des cartes du dashboard CLIENT (AI Credits uniquement)
 * @param state - État du dashboard (utilisateurs, crédits)
 * @param t - Fonction de traduction i18n
 * @param useAiCredits - Toujours true pour famla-app client
 * @returns Array de cartes à afficher
 */
const getDashboardCardsData = (state: any, t: Function, useAiCredits: boolean = true) => {
    // [AI CREDITS] Calcul des métriques
    const creditsQuota = state.creditsQuota || 40;  // Default FREE
    const creditsAvailable = state.creditsAvailable || 0;
    const creditsConsumed = state.creditsConsumedMonth || 0;
    const usagePercentage = creditsQuota > 0 ? Math.round((creditsConsumed / creditsQuota) * 100) : 0;

    // [FAMLA-APP CLIENT] 5 cartes AI Credits (Plan affiché dans l'encart à droite)
    // Carte "utilisation" (usagePercentage) supprimée selon demande
    return [
        {
            title: t('dashboard.totalUsers'),
            iconClass: 'fa-solid fa-users',
            // value: state.totalRegisteredUsers + state.unverifiedCount,
            value: state.totalUsers,
            bgColor: 'bg-info',
        },
        {
            title: t('dashboard.availableCredits'),
            iconClass: 'fa-solid fa-coins',
            value: creditsAvailable,
            bgColor: 'bg-success',
        },
        {
            title: t('dashboard.consumedCredits'),
            iconClass: 'fa-solid fa-chart-line',
            value: creditsConsumed,
            bgColor: 'bg-theme',
        },
        {
            title: t('dashboard.registeredUsers'),
            iconClass: 'fa-solid fa-user-check',
            value: state.totalRegisteredUsers,
            bgColor: 'bg-info',
        },
        {
            title: t('dashboard.unverifiedUsers'),
            iconClass: 'fa-solid fa-user-clock',
            value: state.unverifiedCount,
            bgColor: 'bg-warning',
        },
    ];
};

export default getDashboardCardsData;
